import React from 'react';
import { connect } from 'react-redux';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import {
  AdComponentPropTypes,
  AdComponentDefaultProps,
} from 'client/site-modules/shared/components/ad-unit/ad-unit-prop-types';
import { SRP_AD } from 'site-modules/shared/components/native-ad/utils/constants';
import { SRPSiteServedRetention } from 'site-modules/shared/components/native-ad/srp-site-served-retention/srp-site-served-retention';
import { SrpSiteServedAd } from 'site-modules/shared/components/native-ad/srp-site-served-ad/srp-site-served-ad';

export function SrpAdUI({
  position = '1',
  mobile = AdComponentDefaultProps.mobile,
  slotRenderEndListener = AdComponentDefaultProps.slotRenderEndListener,
  placeholderComponent = AdComponentDefaultProps.placeholderComponent,
  placeholderComponentProps = AdComponentDefaultProps.placeholderComponentProps,
  customTargeting = AdComponentDefaultProps.customTargeting,
  vehicle = AdComponentDefaultProps.vehicle,
  currentVehicle = AdComponentDefaultProps.currentVehicle,
  dependedOnCurrentVehicle = AdComponentDefaultProps.dependedOnCurrentVehicle,
  wrapperClass = AdComponentDefaultProps.wrapperClass,
  siteServedAdsEnabled = AdComponentDefaultProps.siteServedAdsEnabled,
  breakpoints = AdComponentDefaultProps.breakpoints,
  isIvt = AdComponentDefaultProps.isIvt,
  ivtClassName = AdComponentDefaultProps.ivtClassName,
  ...restProps
}) {
  return (
    <SRPSiteServedRetention
      position={position}
      mobile={mobile}
      slotRenderEndListener={slotRenderEndListener}
      placeholderComponent={placeholderComponent}
      placeholderComponentProps={placeholderComponentProps}
      customTargeting={customTargeting}
      vehicle={vehicle}
      currentVehicle={currentVehicle}
      dependedOnCurrentVehicle={dependedOnCurrentVehicle}
      wrapperClass={wrapperClass}
      siteServedAdsEnabled={siteServedAdsEnabled}
      breakpoints={breakpoints}
      isIvt={isIvt}
      ivtClassName={ivtClassName}
      {...restProps}
      adType={SRP_AD}
      siteServedComponent={SrpSiteServedAd}
      wrapperTagClassName="mb-0_75 mb-lg-1"
    />
  );
}

SrpAdUI.propTypes = {
  ...AdComponentPropTypes,
};

const mapStateToProps = state => ({
  mobile: state.mobile,
});

export const stateToPropsConfig = {
  vehicle: bindToPath('vehicle', PageModel),
};

export const SrpAd = connect(mapStateToProps)(connectToModel(SrpAdUI, stateToPropsConfig));
